"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.DefaultSectionWrapper = exports.DefaultFormWrapper = exports.FormContainer = void 0;
var design_language_1 = require("@doordash/design-language");
var styled_components_1 = __importDefault(require("styled-components"));
var MAX_WIDTH_PX = 180;
exports.FormContainer = styled_components_1["default"](design_language_1.InlineChildren).attrs({
    justifyContent: design_language_1.InlineChildren.Justification.SpaceBetween,
    alignItems: design_language_1.InlineChildren.Alignment.FlexStart
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  margin-top: 0 !important;\n  > * {\n    margin-top: 20px !important;\n  }\n  ", "\n"], ["\n  width: 100%;\n  margin-top: 0 !important;\n  > * {\n    margin-top: 20px !important;\n  }\n  ",
    "\n"])), function (props) {
    return props.width
        ? "max-width: " + (props.width >= MAX_WIDTH_PX ? props.width : MAX_WIDTH_PX) + "px"
        : "";
});
exports.DefaultFormWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.DefaultSectionWrapper = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3;
